import { Button, Drawer, Flex, Space, Spin } from "antd"

interface ContractAddPreviewHTMLProps {
  html: string
  saving: boolean
  onClose: () => void
  onClickSaveDraft: () => void
  onClickGenerate: () => void
  onClickSendToApproval: () => void
}

export function ContractAddPreviewHTML({
  html,
  saving,
  onClickSaveDraft,
  onClickGenerate,
  onClickSendToApproval,
  onClose
}: ContractAddPreviewHTMLProps) {
  return (
    <Drawer
      classNames={{ body: "p-1" }}
      open
      width="100VW"
      title={"Contract Preview"}
      onClose={onClose}
    >
      {saving && <Spin fullscreen />}
      <Flex vertical gap={"middle"} className={"size-full"}>
        <iframe
          srcDoc={html}
          className="flex-1 border-0"
          sandbox="allow-same-origin"
          title="Preview"
        />
        <Flex justify={"space-between"} className={"px-2 pb-2"}>
          <Button disabled={saving} onClick={onClose} danger>
            Cancel
          </Button>
          <Space>
            <Button disabled={saving} onClick={onClickGenerate}>
              Generate
            </Button>
            <Button disabled={saving} onClick={onClickSaveDraft}>
              Save as Draft
            </Button>
            <Button
              disabled={saving}
              onClick={onClickSendToApproval}
              type={"primary"}
            >
              Send to Approval
            </Button>
          </Space>
        </Flex>
      </Flex>
    </Drawer>
  )
}
